module.exports = __webpack_public_path__ + "media/images/lens-f4bcb5cf689de0044357fccfe6dc518d.svg";